var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-12',[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"alarm-chart-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }